import { Search, X } from 'lucide-react';
import { hasActiveFilters, NO_FILTERS } from '../../utils/documentSearch';

// Search box + "sent between" dates for a Bullhorn HyreDocs tab's document list.
// Shared by the Candidate, Contact, Placement and Company tabs; the matching
// itself lives in utils/documentSearch. Plain elements (no shared UI kit) so it
// also renders under jest, which cannot resolve that kit's "@/" imports.

const FIELD = 'h-7 text-xs border rounded-md bg-white text-slate-700 px-2';

export default function DocumentSearchBar({ filters, onChange, shown, total, testId = 'doc-search' }) {
  const set = (patch) => onChange({ ...filters, ...patch });
  const active = hasActiveFilters(filters);

  return (
    <div className="mt-3 space-y-2" data-testid={testId}>
      <div className="relative">
        <Search className="w-3.5 h-3.5 text-slate-400 absolute left-2.5 top-1/2 -translate-y-1/2 pointer-events-none" aria-hidden="true" />
        <input
          type="text"
          value={filters.query}
          onChange={(e) => set({ query: e.target.value })}
          placeholder="Search by document, packet, placement or date sent"
          aria-label="Search documents"
          autoComplete="off"
          className={`${FIELD} w-full pl-8 pr-8`}
          data-testid={`${testId}-input`}
        />
        {filters.query && (
          <button
            type="button"
            onClick={() => set({ query: '' })}
            aria-label="Clear search text"
            className="absolute right-1.5 top-1/2 -translate-y-1/2 h-5 w-5 rounded flex items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-100"
            data-testid={`${testId}-clear-query`}
          >
            <X className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      <div className="flex items-center gap-x-3 gap-y-1.5 flex-wrap text-[11px] text-slate-500">
        <span className="font-medium">Sent</span>
        <label className="flex items-center gap-1">
          from
          <input
            type="date"
            value={filters.from}
            max={filters.to || undefined}
            onChange={(e) => set({ from: e.target.value })}
            aria-label="Sent from date"
            className={FIELD}
            data-testid={`${testId}-from`}
          />
        </label>
        <label className="flex items-center gap-1">
          to
          <input
            type="date"
            value={filters.to}
            min={filters.from || undefined}
            onChange={(e) => set({ to: e.target.value })}
            aria-label="Sent to date"
            className={FIELD}
            data-testid={`${testId}-to`}
          />
        </label>
        {active && (
          <>
            <button
              type="button"
              onClick={() => onChange({ ...NO_FILTERS })}
              className="underline text-slate-600 hover:text-slate-900"
              data-testid={`${testId}-clear`}
            >
              Clear all
            </button>
            <span className="ml-auto" data-testid={`${testId}-count`}>
              Showing {shown} of {total}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
